import { getBuildUpdateFlag, setBuildUpdateFlag } from 'config/api-version';
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

const useBuildVersionUpdater = () => {
    const location = useLocation();

    useLayoutEffect(() => {
        const versionUpdateNeeded = getBuildUpdateFlag();

        // If there is an update available and no state passed to route
        if (!location.state && versionUpdateNeeded) {
            window.location.reload();

            setBuildUpdateFlag(false);
        }
    }, [location]);
};

export default useBuildVersionUpdater;
